import {z} from "../../../../../lib";
import {
  OperacionTransferenciasTercerosChequeosComplianceFields,
  OperacionTransferenciaTercerosCuentaFields,
  OperacionTransferenciaTercerosDetalleFields,
  OperacionTransferenciaTercerosFields
} from "./fields";
import {EntityWithIdFields, schemaEntityWithId} from "../../../../../types";
import {OperacionTransferenciaTercerosTipoOperacion} from "./enums";
import {FilePutFields} from "../../../api/file-fields";

export const schemaOperacionTransferenciaTercerosCuentaDetalleProvisional = z.object({
  idProvisional: z.string(),
  [OperacionTransferenciaTercerosCuentaFields.NroCuenta]: z.string().min(4),
  [OperacionTransferenciaTercerosCuentaFields.Titular]: z.string(),
  [OperacionTransferenciaTercerosCuentaFields.CodTipoOperacion]: z.number(),
  [OperacionTransferenciaTercerosCuentaFields.TipoOperacion]: z.string().optional(),
  [OperacionTransferenciaTercerosCuentaFields.Broker]: z.string().optional(),
  [OperacionTransferenciaTercerosCuentaFields.MSB]: z.string().optional(),
  [OperacionTransferenciaTercerosCuentaFields.BancoReceptor]: z.string().optional(),
  [OperacionTransferenciaTercerosCuentaFields.TitularCuenta]: z.string().optional(),
  [OperacionTransferenciaTercerosDetalleFields.Moneda]: z.string(),
  [OperacionTransferenciaTercerosDetalleFields.Monto]: z.string(),
  [OperacionTransferenciaTercerosDetalleFields.MontoEquivalenteUSD]: z.string().nullable().optional(),
  [OperacionTransferenciaTercerosDetalleFields.Destino]: z.string(),
  [FilePutFields.File]: z.instanceof(File),
}).refine(data => !(data[OperacionTransferenciaTercerosCuentaFields.CodTipoOperacion] === OperacionTransferenciaTercerosTipoOperacion.FCC && !data[OperacionTransferenciaTercerosCuentaFields.Broker]), {
  message: "Obligatorio para FCC",
  path: [OperacionTransferenciaTercerosCuentaFields.Broker],
}).refine(data => !(data[OperacionTransferenciaTercerosCuentaFields.CodTipoOperacion] === OperacionTransferenciaTercerosTipoOperacion.FCC && !data[OperacionTransferenciaTercerosCuentaFields.MSB]), {
  message: "Obligatorio para FCC",
  path: [OperacionTransferenciaTercerosCuentaFields.MSB],
}).refine(data => !(data[OperacionTransferenciaTercerosCuentaFields.CodTipoOperacion] === OperacionTransferenciaTercerosTipoOperacion.TRANSFERENCIATERCEROS && !data[OperacionTransferenciaTercerosCuentaFields.BancoReceptor]), {
  message: "Obligatorio para Transferencia Terceros",
  path: [OperacionTransferenciaTercerosCuentaFields.BancoReceptor],
}).refine(data => !(data[OperacionTransferenciaTercerosCuentaFields.CodTipoOperacion] === OperacionTransferenciaTercerosTipoOperacion.TRANSFERENCIATERCEROS && !data[OperacionTransferenciaTercerosCuentaFields.TitularCuenta]), {
  message: "Obligatorio para Transferencia Terceros",
  path: [OperacionTransferenciaTercerosCuentaFields.TitularCuenta],
}).refine(data => !(data[OperacionTransferenciaTercerosCuentaFields.CodTipoOperacion] === OperacionTransferenciaTercerosTipoOperacion.TRANSFERENCIATERCEROS && !data[OperacionTransferenciaTercerosCuentaFields.NroCuenta]), {
  message: "Obligatorio para Transferencia Terceros",
  path: [OperacionTransferenciaTercerosCuentaFields.NroCuenta],
});

export type OperacionTransferenciaTercerosCuentaDetalleProvisional = z.infer<typeof schemaOperacionTransferenciaTercerosCuentaDetalleProvisional>

export const schemaOperacionTransferenciaTercerosInsert = z.object({
  [OperacionTransferenciaTercerosFields.CodPais]: z.number(),
  [OperacionTransferenciaTercerosFields.FechaAprobacion]: z.date().optional().nullable(),
  [OperacionTransferenciaTercerosFields.AsesorFinanciero]: z.string(),
  [OperacionTransferenciaTercerosFields.BitEnvio]: z.boolean(),
  [OperacionTransferenciaTercerosFields.Cuentas]: z.array(schemaOperacionTransferenciaTercerosCuentaDetalleProvisional)
})

export type OperacionTransferenciaTercerosInsert = z.infer<typeof schemaOperacionTransferenciaTercerosInsert>


export const schemaOperacionTransferenciaTercerosDetalleInsert = z.object({
  [OperacionTransferenciaTercerosDetalleFields.Moneda]: z.string(),
  [OperacionTransferenciaTercerosDetalleFields.Monto]: z.number(),
  [OperacionTransferenciaTercerosDetalleFields.MontoEquivalenteUSD]: z.number(),
  [OperacionTransferenciaTercerosDetalleFields.Destino]: z.string(),
})

export type OperacionTransferenciaTercerosDetalleInsert = z.infer<typeof schemaOperacionTransferenciaTercerosDetalleInsert>

export const schemaOperacionTransferenciaTercerosDetalleUpdate = schemaOperacionTransferenciaTercerosDetalleInsert.merge(schemaEntityWithId)
export type OperacionTransferenciaTercerosDetalleUpdate = z.infer<typeof schemaOperacionTransferenciaTercerosDetalleUpdate>

export const schemaOperacionTransferenciasTercerosChequeosComplianceVista = z.object({
  [OperacionTransferenciasTercerosChequeosComplianceFields.IdOperacionTransferenciasTerceros]: z.number(),
  [OperacionTransferenciasTercerosChequeosComplianceFields.MotivoCliente]: z.string().optional().nullable(),
  [OperacionTransferenciasTercerosChequeosComplianceFields.RecibidaInstruccion]: z.boolean(),
  [OperacionTransferenciasTercerosChequeosComplianceFields.DocumentacionEnOrden]: z.boolean(),
  [OperacionTransferenciasTercerosChequeosComplianceFields.BeneficiarioRegulado]: z.boolean(),
  [OperacionTransferenciasTercerosChequeosComplianceFields.InstruccionFirmada]: z.boolean(),
  [OperacionTransferenciasTercerosChequeosComplianceFields.PagoDirecto]: z.boolean(),
  [OperacionTransferenciasTercerosChequeosComplianceFields.DetallePagoDirecto]: z.string().optional().nullable(),
  [OperacionTransferenciasTercerosChequeosComplianceFields.HitBusqueda]: z.boolean(),
  [OperacionTransferenciasTercerosChequeosComplianceFields.DetalleHitBusqueda]: z.string().optional().nullable(),
  [OperacionTransferenciasTercerosChequeosComplianceFields.Callback]: z.boolean(),
  [OperacionTransferenciasTercerosChequeosComplianceFields.DetalleCallback]: z.string().optional().nullable(),
  [OperacionTransferenciasTercerosChequeosComplianceFields.Opinion]: z.string().optional().nullable(),
  [OperacionTransferenciasTercerosChequeosComplianceFields.Situacion]: z.string().optional().nullable(),
  [OperacionTransferenciasTercerosChequeosComplianceFields.Activo]: z.boolean()
}).merge(schemaEntityWithId)

export type OperacionTransferenciasTercerosChequeosComplianceVista = z.infer<typeof schemaOperacionTransferenciasTercerosChequeosComplianceVista>

export const schemaOperacionTransferenciasTercerosChequeosComplianceUpdate = schemaOperacionTransferenciasTercerosChequeosComplianceVista.omit({
  [OperacionTransferenciasTercerosChequeosComplianceFields.IdOperacionTransferenciasTerceros]: true,
  [OperacionTransferenciasTercerosChequeosComplianceFields.Activo]: true,
})

export type OperacionTransferenciasTercerosChequeosComplianceUpdate = z.infer<typeof schemaOperacionTransferenciasTercerosChequeosComplianceUpdate>

export const schemaOperacionTransferenciasTercerosChequeosComplianceInsert = schemaOperacionTransferenciasTercerosChequeosComplianceVista.omit({
  [OperacionTransferenciasTercerosChequeosComplianceFields.IdOperacionTransferenciasTerceros]: true,
  [OperacionTransferenciasTercerosChequeosComplianceFields.Activo]: true,
  [EntityWithIdFields.Id]: true,
})

export type OperacionTransferenciasTercerosChequeosComplianceInsert = z.infer<typeof schemaOperacionTransferenciasTercerosChequeosComplianceInsert>

export const schemaOperacionTransferenciaTercerosFinalizar = z.object({
  [OperacionTransferenciasTercerosChequeosComplianceFields.IdOperacionTransferenciasTerceros]: z.number(),
  [OperacionTransferenciaTercerosFields.NroOperacion]: z.string(),
})

export type OperacionTransferenciaTercerosFinalizar = z.infer<typeof schemaOperacionTransferenciaTercerosFinalizar>